export const DailyPriceTypes = {
  CUSTOM_LENGTH: 'CUSTOM_LENGTH',
  CALENDAR_MONTH_DAYS: 'CALENDAR_MONTH_DAYS',
  CONVERTED_WEEKLY: 'CONVERTED_WEEKLY',
  CONVERTED_ANNUAL: 'CONVERTED_ANNUAL',
};

export const MoveInDateOptionsKeys = {
  EARLIER_THAN: 'EARLIER_THAN',
  RANGE: 'RANGE',
  NO_LIMIT: 'NO_LIMIT',
  ACTUAL_DAYS: 'ACTUAL_DAYS',
};

export const MoveOutDateOptionsKeys = {
  LATER_THAN: 'LATER_THAN',
  RANGE: 'RANGE',
  NO_LIMIT: 'NO_LIMIT',
  ACTUAL_DAYS: 'ACTUAL_DAYS',
};
export const MoveInDateOptions = {
  EARLIER_THAN: 'Move in earlier than the selected date',
  RANGE: 'Move in within a date range',
  NO_LIMIT: 'No limit',
  ACTUAL_DAYS:
    'Charge remaining days according to actual days of occupancy in the corresponding month',
};

export const MoveOutDateOptions = {
  LATER_THAN: 'Move out later than the selected date',
  RANGE: 'Move out within a date range',
  NO_LIMIT: 'No limit',
  ACTUAL_DAYS:
    'Charge remaining days according to actual days of occupancy in the corresponding month',
};

export const CustomLengthEnum = {
  TWENTY_EIGHT: 28,
  TWENTY_NINE: 29,
  THIRTY: 30,
  THIRTY_POINT_THREE_THREE: 30.33,
  THIRTY_ONE: 31,
  SEVEN: 7,
  REGULAR_YEAR: 365,
  LEAP_YEAR: 366,
};

export const CustomLengthValueEnum = Object.fromEntries(
  Object.entries(CustomLengthEnum).map(([key, value]) => [value, key]),
);
